/**
 * IngredientsTab — T26.
 * Per-product library editor for the 'ingredient' parameter type.
 */
import LibraryEditor from './LibraryEditor';

interface IngredientsTabProps {
  canWrite: boolean;
}

export default function IngredientsTab({ canWrite }: IngredientsTabProps) {
  return <LibraryEditor type="ingredient" canWrite={canWrite} perProduct />;
}
